import React from "react";
import { IEmployeeEntity } from "../../../common/controls/Relations/RequestControl";
import { IIssueWorkflowData } from "../../ajaxWorkflowModal/WorkflowContext";
import { ControlType, IResourceListItem } from "../ResourcesControl/Models";
import { IResourceListItemBase, parseFromString, parseToString } from "../ResourcesControl/ParseResourceString";
import ResourcesEditor from "../ResourcesControl/ResourcesEditor";

export interface IProps {
	refControl: string,
	errorText: string,
	maxRows: number,
	loadOnFocus: boolean;
	name: string,
	onSet?: (value: IResourceListItem[]) => void,
	issueWorkflowData?: IIssueWorkflowData,

	controlNotifierId: string,
	multiple: boolean,
	kind: string,
	filterId: string,
	filters: string;
	controlType: ControlType,
	showGridTabs: string,

	resourcesGridColumns: any,
	relatedResourcesGridColumns: any,
	relatedEmployeesResourcesGridColumns: any,
	servicesGridColumns: any,

	requestId: string,
	isModal: boolean,

	isLogSystemIntegrationAvailable: boolean,
	isLogPlusIntegrationAvailable: boolean,
	isDemo: boolean,
	manageFiltersPermission: boolean,
	
	employeesSource: string,
}

export default function WorkflowResourcesDataCombobox(props: IProps) {

	const [resources, setResources] = React.useState<IResourceListItem[]>([]);
	const [connectedEmployees, setConnectedEmployees] = React.useState<IResourceListItemBase[]>(null);

	const idControlRef = React.useRef<HTMLInputElement>();

	React.useEffect(() => {
		idControlRef.current = document.querySelector("input[data-ref='" + props.refControl + "']");
		
		if (idControlRef.current.value) {

			let value = parseFromString(idControlRef.current.value);
			setResources(value);

			if (props.onSet)
				props.onSet(value);
		} else {
			if (props.onSet)
				props.onSet([]);
		}
	}, []);

	React.useEffect(() => {
		if (props.employeesSource === "PersonProfiles" || props.employeesSource === "PersonProfiles.Value") {
			var empl = props.issueWorkflowData["PersonProfiles.Value"];
			detectChange(empl?.employees);
		}
	}, [props.issueWorkflowData["PersonProfiles.Value"]]);

	React.useEffect(() => {
		if (props.employeesSource === "Accesses" || props.employeesSource === "Accesses.Value") {
			var empl = props.issueWorkflowData["Accesses.Value"];
			detectChange(empl?.employees);
		}
	}, [props.issueWorkflowData["Accesses.Value"]]);

	React.useEffect(() => {
		if (props.employeesSource === "Authorizations" || props.employeesSource === "Authorizations.Value") {
			var empl = props.issueWorkflowData["Authorizations.Value"];
			detectChange(empl?.employees);
		}
	}, [props.issueWorkflowData["Authorizations.Value"]]);


	function detectChange(employeesFromRelations: IEmployeeEntity[]) {
		if (!employeesFromRelations)
			return;

		if (connectedEmployees) {
			detectDeletedEmployee(employeesFromRelations);
		}

		setConnectedEmployees(employeesFromRelations.map(x => ({
			Id: x.id,
			Name: x.name,
		})));
	}

	function detectDeletedEmployee(employeesFromRelations: IEmployeeEntity[]) {
		for (let i = 0; i < connectedEmployees.length; i++) {
			let connectedEmployee = connectedEmployees[i];
			let exist = employeesFromRelations.filter(x => x.id === connectedEmployee.Id)[0];
			if (!exist)
			{
				handleChangeResources([]);
				break;
			}
		}
	}

	function handleChangeResources(newResources: IResourceListItem[]) {
		setResources(newResources);
		idControlRef.current.value = parseToString(newResources);

		if (props.onSet)
			props.onSet(newResources);
	}

	return <ResourcesEditor
		errorText={props.errorText}
		controlNotifierId={props.controlNotifierId}
		controlType={props.controlType}
		multiple={props.multiple}
		filterId={props.filterId}
		filters={props.filters}
		kind={props.kind}
		onChange={handleChangeResources}
		resources={resources}
		showGridTabs={props.showGridTabs}

		relatedEmployeesResourcesGridColumns={props.relatedEmployeesResourcesGridColumns}
		relatedResourcesGridColumns={props.relatedResourcesGridColumns}
		resourcesGridColumns={props.resourcesGridColumns}
		servicesGridColumns={props.servicesGridColumns}
		manageFiltersPermission={props.manageFiltersPermission}

		requestId={props.requestId}
		isModal={props.isModal}
		disabled={false}
		isLogSystemIntegrationAvailable={props.isLogSystemIntegrationAvailable}
		loadOnFocus={props.loadOnFocus}
		maxRows={props.maxRows}

		getEmployeesValue={() => {
			if (!props.employeesSource)
				return false;

			if (props.employeesSource !== "PersonProfiles"
				&& props.employeesSource !== "PersonProfiles.Value"

				&& props.employeesSource !== "Accesses"
				&& props.employeesSource !== "Accesses.Value"

				&& props.employeesSource !== "Authorizations"
				&& props.employeesSource !== "Authorizations.Value"
			) {
				console.warn(`Unknown configuration employee source: "${props.employeesSource}".`)
				return false;
			}

			if (!connectedEmployees)
				return "";

			return parseToString(connectedEmployees);
		}}
	/>;
}